<template>

	<div class="auth">
		<div class="auth__container">
			<div class="row">
				<div class="col-12">
					<h1>
						{{ t('auth.title') }}
					</h1>
				</div>
			</div>

			<!-- AUTH -->
			<form @submit.prevent="validateAuth('auth')" data-vv-scope="auth">
				<div class="row">
					<div class="col-12">
						<form-message :messages="getMessage('auth')"></form-message>
					</div>
				</div>
				<div class="row">
					<!-- login -->
					<div class="col-12 form-group required">
						<label for="auth__login">{{ t('auth.login') }}</label>
						<input
								v-model="form.login"
								v-validate="'required|min:3'"
								:class="validClasses('auth.username')"
								name="username"
								type="text"
								class="form-control"
								id="auth__login"
								:data-vv-as="t('field.username')"
								:readonly="form.loading"
						>
						<div v-if="isInValid('auth.username')" class="invalid-feedback">
							{{ errors.first('auth.username') }}
						</div>
					</div>
					<!-- PASSWORD -->
					<div class="col-12 form-group required">
						<label for="auth__password">{{ t('auth.password') }}</label>
						<input
								v-model="form.password"
								v-validate="'required'"
								:class="validClasses('auth.password')"
								name="password"
								type="password"
								class="form-control"
								id="auth__password"
								:data-vv-as="t('field.password')"
								:readonly="form.loading"
						>
						<div v-if="isInValid('auth.password')" class="invalid-feedback">
							{{ errors.first('auth.password') }}
						</div>
					</div>
				</div>
				<div class="row">
					<!--<div class="col-12">
						<vue-recaptcha
								ref="captcha-scope-auth"
								:sitekey="sitekey"
								size="invisible"
								@verify="postAuth"
								@expired="onCaptchaExpired()"
						>
						</vue-recaptcha>
					</div>-->
					<div class="col-12 d-flex align-items-center flex-wrap flex-md-nowrap justify-content-center justify-content-md-between">
						<button class="btn btn-primary" :disabled="form.loading">{{ t('auth.btn.login') }}</button>
						<router-link class="btn btn-link mt-4 mt-md-0" :to="{name: 'Recover'}">{{ t('auth.forgot.message') }}
						</router-link>
					</div>
				</div>
			</form>


		</div>
	</div>

</template>
<script>
	import Vuex from 'vuex';
	import {Validator} from 'vee-validate';
	import {instance} from '@/api';
	import {authApi} from '@/api';
	/*import VueRecaptcha from 'vue-recaptcha';*/
	import FormMessage from '@/components/parts/form-message';
	import _ from 'lodash';



	export default {
		name: 'Auth',
		components: {
			/*VueRecaptcha,*/
			FormMessage
		},
		data() {
			return {
				form: {
					login: '',
					password: '',
					loading: false,
					message: {
						state: '',
						text: ''
					}


				}
			}
		},
		computed: {
			...Vuex.mapState([
				'lang'
			]),
			...Vuex.mapGetters({
				sitekey: 'getSitekey'
			})
		},
		watch: {
			lang(lng) {
				//Change messages lang on chenge
				Validator.localize(lng, window.validate.dictionary[lng]);

			},
		},
		mounted() {

			//window.aut = this;
			//console.log(authApi);
			this.deleteMessage('auth');
		},
		methods: {
			/*onCaptchaExpired() {
				//Refresh captcha
				this.$refs['captcha-scope-auth'].reset();
				this.form.loading = false;
			},*/

			validateAuth(scope) {
				this.form.loading = true;
				this.$store.commit('addLoad', 'authUser');
				this.deleteMessage('auth');

				this.$validator.validateAll(scope).then((result) => {
					if (result) {
						// eslint-disable-next-line
						//console.info('Form Submitted: ' + scope);
						//this.$refs['captcha-scope-auth'].execute();
						this.postAuth();

					}else{
						this.form.loading = false;
						this.$store.commit('endLoad', 'authUser');
					}
				});
			},

			postAuth(recaptchaToken) {
				const scope = 'auth';

				this.errors.clear();
				instance.post(authApi.auth, {
					username: this.form.login,
					password: this.form.password,
					recaptcha: recaptchaToken
				})
					.then((responce) => {

						if (responce.data.status === 'SUCCESS' && responce.data.content && responce.data.content.id) {

							this.$store.commit('setUser', responce.data.content);
						} else if (responce.data.status === 'ERROR' && !responce.data.user) {
							if(!_.isEmpty(responce.data.fields)){
								this.handleSipleValidation(responce.data.fields);

								//Recaptcha is virtual field, so add error in form message
								if(responce.data.fields['recaptcha']){
									this.addMessage( {
										scope: scope,
										state: 'danger',
										text: this.t(responce.data.fields['recaptcha'])
									});
								}
							}else{
								this.handleSipleValidation({
									'username': 'auth.username.wrong',
									'password': "auth.password.wrong"
								});
								this.restMessageHandler(responce.data.status, scope, responce.data.message)
							}


						} else {
							this.addMessage( {
								scope: scope,
								state: 'warning',
								text: this.t('api.problem.network')
							});
						}

					})
					.catch(() => {
						this.addMessage( {
							scope: scope,
							state: 'warning',
							text: this.t('api.problem.network')
						});
					})
					.then(() => {
						this.form.loading = false;
						this.$store.commit('endLoad', 'authUser');
						/*if (this.$refs['captcha-scope-auth']) {
							this.$refs['captcha-scope-auth'].reset();
						}*/

					})
			}

		}
	}
</script>
<style lang="scss">
	@import "../../scss/components/auth";
</style>